import React from "react";
import WithHoldingTaxRateGenericSkeleton from "./WithHoldingTaxRateGenericSkeleton";

function WithHoldingTaxRateDetailSkeleton() {
  return (
    <>
      <WithHoldingTaxRateGenericSkeleton />
    </>
  );
}

export default WithHoldingTaxRateDetailSkeleton;
